import React, { useState, useMemo } from 'react';
import ItemPickerNativeProps from "./props";
import "./styles.scss";

function ItemPickerNative(props: ItemPickerNativeProps) {
  const { pickerType, selected, label, options,  onChange } = props;
  const [selectedValue, setSelectedValue] = useState(selected ?? '');
  const pickerTypeLower = useMemo(() => pickerType?.toLowerCase(), [pickerType]);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedValue(event.target.value);
    onChange?.(event, pickerTypeLower);
  };

  return (
    <div className="item-picker-native" data-e2e="item-picker-native">
      <label className="item-picker-native__label" htmlFor={`item-picker-native__${pickerTypeLower}`}>{label}</label>

        <select className="item-picker-native__select" id={`item-picker-native__${pickerTypeLower}`} value={selectedValue} onChange={handleChange}>
          {options?.map((option) => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
    </div>
  );
}

export default React.memo(ItemPickerNative);